import s from './styles.module.scss';
import { getReadingInfo, hiddenThresholds } from '../../utils/get-reading-info';

import type { ReadingType } from 'infrastructure/enums';
import type {
  StatusKeys,
  TStatuses,
  Value,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { FC } from 'react';

interface ReadingCellProps {
  values: Value;
  statuses: TStatuses;
  readingType: ReadingType;
}

const ReadingCell: FC<ReadingCellProps> = ({
  values,
  statuses,
  readingType,
}) => {
  return (
    <div data-cy="reading-values" className={s['reading-items']}>
      {Object.keys(values).map((threshold, index) => {
        if (hiddenThresholds.includes(threshold)) {
          return null;
        }
        const { className, key, value, unit } = getReadingInfo(
          statuses,
          values,
          threshold as StatusKeys,
        );

        return (
          <p className={s[className]} key={readingType + index}>
            <span>{key === 'spo2' ? 'SpO2' : key} </span>
            <span>{`${value} ${unit}`}</span>
          </p>
        );
      })}
    </div>
  );
};
export default ReadingCell;
